import AppSpinner from "./AppSpinner";

interface CenteredSpinnerProps {
  size: "sm" | "md" | "lg" | "xl";
}

const CenteredSpinner = ({ size }: CenteredSpinnerProps) => {
  return (
    <div
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      }}
    >
      <AppSpinner size={size} />
    </div>
  );
};

export default CenteredSpinner;
